exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".range-selector-button {\n  background: #ffda22;\n  border: 1px solid black;\n  display: inline-block;\n  width: 0.88889rem;\n  height: 0.88889rem;\n  line-height: 0.66667rem;\n  padding: 0;\n  font-size: 1rem;\n  -webkit-border-radius: 50%;\n          border-radius: 50%;\n  color: black;\n  margin: 0 0.25rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["C://Users//T.ETTLING//Desktop//VirGroup Webseiten//src//scss"]}!./src/components/RangeSelector.scss
// module id = 879
// module chunks = 0